import ErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import MobileFooterBar from "@/infrastructure/MobileFooterBar/mobileFooterBar.component";
import Navbar from "@/infrastructure/Navbar/navbar.component";
import Sidebar from "@/infrastructure/Sidebar/sidebar.component";
import React from "react";

type BasePageProps = {
  children: React.ReactNode;
  currPage: string;
};

const BasePage: React.FC<BasePageProps> = ({ children, currPage }) => {
  return (
    <div className="flex flex-col h-full">
      <ErrorBoundary>
        <Navbar />
      </ErrorBoundary>
      <div className="flex flex-1 overflow-hidden h-full">
        <ErrorBoundary>
          <Sidebar currPage={currPage} />
        </ErrorBoundary>
        <div className="flex flex-col flex-auto md:p-4 w-full overflow-x-hidden">
          <ErrorBoundary>{children}</ErrorBoundary>
        </div>
      </div>
      <ErrorBoundary>
        <MobileFooterBar currPage={currPage} />
      </ErrorBoundary>
    </div>
  );
};

export default BasePage;
